export const entities = {
    search: 'search',
    license: 'license',
    carTypes: 'carTypes',
    scrolls: 'scrolls',
    filters: 'filters',
    ratingParams: 'ratingParams',
    enablerFeatures: 'enablerFeatures'
};

export const urlParams = {
    cityFrom: 'CityFrom',
    cityTo: 'CityTo',
    truckType: 'TruckType',
    period: 'Period',
    truckWeightFrom: 'TruckWeightFrom',
    truckWeightTo: 'TruckWeightTo',
    truckVolumeFrom: 'TruckVolumeFrom',
    truckVolumeTo: 'TruckVolumeTo',
    idFrom: 'IdFrom',
    typeFrom: 'TypeFrom',
    idTo: 'IdTo',
    typeTo: 'TypeTo',
    transitionSource: 'transition_source',
    payByBankCardStatus: 'direct_payment_status',
    payPeriod: 'PayPeriod',
};

export const externalOriginQuery = 'external_origin';
